export const ROLES = {
  ADMINISTRATIVO: "administrativo",
  AGENCIA: "agencia",
  COMERCIAL: "comercial",
  EDIFICIO: "edificio",
  GERENCIA: "gerencia",
  SUPERADMIN: "superadmin",
};
